module.exports = __webpack_public_path__ + "img/no_jurisdiction.60e29470.svg";